import { labels } from './labels';

/** A load error with a **Try again** button (QA-36, QA-101). `onRetry` puts the screen back to its loading state. */
export function LoadError({ text, onRetry }: { text: string; onRetry: () => void }) {
  return (
    <div className="notice notice--crit notice--action" role="alert">
      <p>{text}</p>
      <button type="button" className="btn" onClick={onRetry}>
        {labels.retry}
      </button>
    </div>
  );
}
